import { render, staticRenderFns } from "./contrastReport.vue?vue&type=template&id=60fa6c9b&scoped=true&"
import script from "./contrastReport.vue?vue&type=script&lang=js&"
export * from "./contrastReport.vue?vue&type=script&lang=js&"
import style0 from "./contrastReport.vue?vue&type=style&index=0&id=60fa6c9b&prod&lang=scss&scoped=true&"
import style1 from "./contrastReport.vue?vue&type=style&index=1&id=60fa6c9b&prod&lang=scss&"
import style2 from "./contrastReport.vue?vue&type=style&index=2&id=60fa6c9b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fa6c9b",
  null
  
)

export default component.exports